﻿﻿export interface ITicketGroupCategory {
    id: number;
    description: string;
    value: string;
}
